<template>
  <div class="animated fadeIn">
    <b-form-group label="Add On(s)" label-cols="2">
      <b-button
        v-b-toggle="`addOns-${sample.test_package_sample_id}`"
        :variant="sample.add_ons.length ? 'primary' : 'dark'"
        block
        >Options</b-button
      >
      <b-collapse :id="`addOns-${sample.test_package_sample_id}`" class="mt-2">
        <custom-form-checkbox-group
          v-if="addOns.length"
          v-model="sample.add_ons"
          :lg="2"
          :md="2"
          :options="
            addOns.map(item => ({
              text: item.name,
              value: item.id,
              icon: 'cube'
            }))
          "
          @change="handleSampleChange"
        />
      </b-collapse>
    </b-form-group>
  </div>
</template>

<script>
import CustomFormCheckboxGroup from "@/components/shared/form/CustomFormCheckboxGroup";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectTissueSampleFormGroup",
  components: { CustomFormCheckboxGroup },
  props: {
    submissionId: {
      type: String,
      default: ""
    },
    sampleId: {
      type: String,
      default: ""
    },
    addOns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    sampleList() {
      return this.submission(this.submissionId).samples;
    },
    sample() {
      return this.sampleList.find(
        sample => sample.test_package_sample_id === this.sampleId
      );
    }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSampleChange() {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.sampleList,
        name: "samples"
      });
    }
  }
};
</script>
